import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	Resolve,
	Router,
	RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from './../../../../core/auth/service/auth.service';

@Injectable()
export class ForgotPasswordTokenResolverGuard implements Resolve<any> {
	constructor(private service: AuthService, private router: Router) {}

	resolve(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<any> {
		if (route.params && route.params.token) {
			return this.service
				.forgotPasswordVerifyToken(route.params.token)
				.pipe(
					catchError(() => {
						this.router.navigate(['auth/forgot-password-invalid-token']);
						return this.clearUser();
					})
				);
		} else {
			return this.clearUser();
		}
	}

	clearUser() {
		return of({});
	}
}
